import { ArrowRight, Plane, Calendar, Users, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const FEATURED_SERVICES = [
  {
    id: '1',
    title: 'Airport Transfers',
    slug: 'airport-transfers',
    short_description: 'Seamless pickup and drop-off at Brussels Airport with flight tracking and meet & greet service.',
    image_url: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=800&q=80',
    icon: Plane,
    highlight: 'Flight Tracking Included',
  },
  {
    id: '2',
    title: 'Corporate Travel',
    slug: 'corporate-travel',
    short_description: 'Professional transportation for executives, meetings, and business events across Belgium.',
    image_url: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=800&q=80',
    icon: Calendar,
    highlight: 'Priority Scheduling',
  },
  {
    id: '3',
    title: 'Special Events',
    slug: 'special-events',
    short_description: 'Make your wedding, gala, or celebration unforgettable with our luxury fleet.',
    image_url: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=800&q=80',
    icon: Users,
    highlight: 'Red Carpet Service',
  },
  {
    id: '4',
    title: 'Hourly Charter',
    slug: 'hourly-charter',
    short_description: 'Flexible chauffeur service by the hour for shopping, tours, or multiple appointments.',
    image_url: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=800&q=80',
    icon: Clock,
    highlight: 'Flexible Scheduling',
  },
];

const FeaturedServicesSection = () => {
  return (
    <section className="py-20 bg-neutral-cream" aria-labelledby="services-heading">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary uppercase tracking-widest text-sm font-medium">Our Services</span>
          <h2 id="services-heading" className="text-3xl md:text-4xl font-serif font-bold text-secondary mt-3 mb-4">
            Premium Transportation Solutions
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg">
            Experience unparalleled comfort and reliability with our range of luxury transportation services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURED_SERVICES.map((service) => {
            const Icon = service.icon;
            return (
              <Link
                key={service.id}
                to={`/services/${service.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image_url}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary/90 text-white text-xs font-medium rounded-full">
                      <Icon className="w-3 h-3" />
                      {service.highlight}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-serif font-bold text-secondary mb-2 group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">{service.short_description}</p>
                  <div className="flex items-center text-primary font-medium text-sm group-hover:gap-2 transition-all">
                    Learn more <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center px-8 py-4 bg-secondary text-white font-medium rounded-lg hover:bg-secondary-dark transition-colors"
          >
            View All Services <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedServicesSection;
